export default "__VITE_ASSET__cd96bb10__"